export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const GET_MEMBER = `${API_BASE_URL}/member/me`;
export const FETCH_ALL_MEMBERS = `${API_BASE_URL}/member/all`;
export const SET_PASSWORD = `${API_BASE_URL}/member/set-password`;
export const RESET_PASSWORD = `${API_BASE_URL}/member/reset-password`;
export const MEMBER_LOGIN = `${API_BASE_URL}/member/login`;
export const DELETE_MEMBER = `${API_BASE_URL}/member`;
export const ENABLE_MEMBER = `${API_BASE_URL}/member`;
export const INVITE_MEMBER = `${API_BASE_URL}/member/invite`;
export const TOGGLE_MEMBER_ROLE = (memberId: string) =>
  `${API_BASE_URL}/member/${memberId}/role`;
export const UPDATE_PHONE_NUMBER = (memberId: string) =>
  `${API_BASE_URL}/member/${memberId}/phone-number`;
export const UPLOAD_PDF = `${API_BASE_URL}/upload/pdf`;
export const UPLOAD_IMAGE = `${API_BASE_URL}/upload/image`;

export const FETCH_ALL_DOCUMENTS = `${API_BASE_URL}/upload/all`;
export const FETCH_SIGNED_DOCUMENTS = `${API_BASE_URL}/upload/signed-url`;
export const FETCH_SIGNED_DOCUMENT_FROM_EMAIL = (documentId: string) =>
  `${API_BASE_URL}/upload/signed-url/email?documentId=${documentId}`;

export const FETCH_ALL_REMINDERS = `${API_BASE_URL}/upload/reminders/all`;
export const SEND_REMINDER_EMAIL = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}`;
export const TOGGLE_REMINDER_EMAIL_AS_RENEWED = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}`;
export const DELETE_DOCUMENT = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}`;
export const TOGGLE_DOCUMENT_AS_APPLIED = (documentId: string) =>
  `${API_BASE_URL}/member/reminder/doc/${documentId}/applied`;

export const GET_SETTINGS = `${API_BASE_URL}/member/settings`;
export const UPDATE_SETTINGS = `${API_BASE_URL}/member/settings`;
export const UPDATE_NOTIFICATION_SETTINGS = `${API_BASE_URL}/member/notification-settings`;

export const UPDATE_DOCUMENT = (documentId: string) =>
  `${API_BASE_URL}/upload/doc/${documentId}`;

// Driver endpoints
export const FETCH_ALL_DRIVERS = `${API_BASE_URL}/driver/all`;
export const CREATE_DRIVER = `${API_BASE_URL}/driver`;
export const GET_DRIVER = (driverId: string) =>
  `${API_BASE_URL}/driver/${driverId}`;
export const UPDATE_DRIVER = (driverId: string) =>
  `${API_BASE_URL}/driver/${driverId}`;
export const DELETE_DRIVER = (driverId: string) =>
  `${API_BASE_URL}/driver/${driverId}`;

// Labour endpoints
export const FETCH_ALL_LABOURS = `${API_BASE_URL}/labour/all`;
export const CREATE_LABOUR = `${API_BASE_URL}/labour`;
export const GET_LABOUR = (labourId: string) =>
  `${API_BASE_URL}/labour/${labourId}`;
export const UPDATE_LABOUR = (labourId: string) =>
  `${API_BASE_URL}/labour/${labourId}`;
export const DELETE_LABOUR = (labourId: string) =>
  `${API_BASE_URL}/labour/${labourId}`;

// Warehouse member endpoints
export const FETCH_ALL_WAREHOUSE_MEMBERS = `${API_BASE_URL}/warehouse-members/all`;
export const CREATE_WAREHOUSE_MEMBER = `${API_BASE_URL}/warehouse-members`;
export const GET_WAREHOUSE_MEMBER = (warehouseMemberId: string) =>
  `${API_BASE_URL}/warehouse-members/${warehouseMemberId}`;
export const UPDATE_WAREHOUSE_MEMBER = (warehouseMemberId: string) =>
  `${API_BASE_URL}/warehouse-members/${warehouseMemberId}`;
export const DELETE_WAREHOUSE_MEMBER = (warehouseMemberId: string) =>
  `${API_BASE_URL}/warehouse-members/${warehouseMemberId}`;

// Rake endpoints
export const FETCH_ALL_RAKES = `${API_BASE_URL}/upload/rake`;
export const GET_RAKE = (rakeMasterId: string) =>
  `${API_BASE_URL}/upload/rake/${rakeMasterId}`;
export const DELETE_RAKE = (rakeMasterId: string) =>
  `${API_BASE_URL}/upload/rake/${rakeMasterId}`;
export const RAKE_REPORT = `${API_BASE_URL}/rake/report`;
export const SIGNED_URL_UPLOAD = `${API_BASE_URL}/upload/signed-url/upload`;
export const PARSE_EXCEL = `${API_BASE_URL}/upload/parse-excel`;
export const GET_ACTIVE_RAKE = `${API_BASE_URL}/rake/active`;
export const COMPLETE_RAKE = (rakeMasterId: string) =>
  `${API_BASE_URL}/rake/${rakeMasterId}/complete`;
export const GET_RAKE_VEHICLE_UPLOADS = (
  rakeMasterId: string,
  vehicleNumber: string
) =>
  `${API_BASE_URL}/rake/${rakeMasterId}/uploads/${encodeURIComponent(
    vehicleNumber
  )}`;

// Rake document endpoints
export const RAKE_DOCUMENT_PRESIGN = (rakeMasterId: string) =>
  `${API_BASE_URL}/rake/${rakeMasterId}/documents/presign`;
export const RAKE_DOCUMENT_CONFIRM = (rakeMasterId: string) =>
  `${API_BASE_URL}/rake/${rakeMasterId}/documents/confirm`;
export const RAKE_DOCUMENTS = (rakeMasterId: string) =>
  `${API_BASE_URL}/rake/${rakeMasterId}/documents`;
export const DELETE_RAKE_DOCUMENT = (rakeDocumentId: string) =>
  `${API_BASE_URL}/rake/documents/${rakeDocumentId}`;

// Rake driver endpoints
export const FETCH_ALL_RAKE_DRIVERS = `${API_BASE_URL}/rake-drivers/all`;
export const CREATE_RAKE_DRIVER = `${API_BASE_URL}/rake-drivers`;
export const GET_RAKE_DRIVER = (rakeDriverId: string) =>
  `${API_BASE_URL}/rake-drivers/${rakeDriverId}`;
export const UPDATE_RAKE_DRIVER = (rakeDriverId: string) =>
  `${API_BASE_URL}/rake-drivers/${rakeDriverId}`;
export const DELETE_RAKE_DRIVER = (rakeDriverId: string) =>
  `${API_BASE_URL}/rake-drivers/${rakeDriverId}`;

// Tracking endpoints
export const TRACKING_RAKE_DRIVERS = (rakeMasterId: string) =>
  `${API_BASE_URL}/tracking/rake/${rakeMasterId}/drivers`;
export const TRACKING_DRIVER_TRAIL = (
  rakeMasterId: string,
  rakeDriverId: string
) =>
  `${API_BASE_URL}/tracking/rake/${rakeMasterId}/driver/${rakeDriverId}/trail`;
export const TRACKING_SYNC_NOW = `${API_BASE_URL}/tracking/sync-now`;

// Trip endpoints
export const GET_ACTIVE_RAKE_TRIPS = `${API_BASE_URL}/trips`;
export const GET_TRIPS_BY_RAKE = (rakeMasterId: string) =>
  `${API_BASE_URL}/trips/by-rake/${rakeMasterId}`;
export const GET_TRIPS_BY_VEHICLE = (vehicleNumber: string) =>
  `${API_BASE_URL}/trips/by-vehicle/${encodeURIComponent(vehicleNumber)}`;
export const GET_TRIP = (tripId: string) =>
  `${API_BASE_URL}/trips/${tripId}`;

// Chat endpoints
export const CHAT_ASK = `${API_BASE_URL}/chat/ask`;
export const CHAT_SESSIONS = `${API_BASE_URL}/chat/sessions`;
export const CHAT_SESSION = (sessionId: string) =>
  `${API_BASE_URL}/chat/sessions/${sessionId}`;

// Workflow endpoints
export const WORKFLOW_STATS = `${API_BASE_URL}/upload/workflow/stats`;
export const DELETE_WORKFLOW_TASK = (workflowTaskId: string) =>
  `${API_BASE_URL}/upload/workflow/${workflowTaskId}`;

// Stats endpoints
export const STATS_OVERVIEW = `${API_BASE_URL}/stats/overview`;
export const STATS_WORKFLOW = `${API_BASE_URL}/stats/workflow`;
export const STATS_WORKFLOW_TREND = `${API_BASE_URL}/stats/workflow/trend`;
export const STATS_WEIGHT = `${API_BASE_URL}/stats/weight`;
export const STATS_RAKE = `${API_BASE_URL}/stats/rake`;
export const STATS_VEHICLES = `${API_BASE_URL}/stats/vehicles`;
export const STATS_OPERATIONS = `${API_BASE_URL}/stats/operations`;
export const STATS_DAILY_SUMMARY = `${API_BASE_URL}/stats/daily-summary`;

// Weightment endpoints
export const WEIGHTMENT_OVERVIEW = `${API_BASE_URL}/weightment/overview`;
export const WEIGHTMENT_TREND = `${API_BASE_URL}/weightment/trend`;
export const WEIGHTMENT_BY_MATERIAL = `${API_BASE_URL}/weightment/by-material`;
export const WEIGHTMENT_BY_PARTY = `${API_BASE_URL}/weightment/by-party`;
export const WEIGHTMENT_BY_VEHICLE = `${API_BASE_URL}/weightment/by-vehicle`;
export const WEIGHTMENT_BY_LOCATION = `${API_BASE_URL}/weightment/by-location`;
export const WEIGHTMENT_BY_LOGISTICS = `${API_BASE_URL}/weightment/by-logistics`;
export const WEIGHTMENT_BY_STATE = `${API_BASE_URL}/weightment/by-state`;
export const WEIGHTMENT_SLIPS = `${API_BASE_URL}/weightment/slips`;
export const WEIGHTMENT_HOURLY = `${API_BASE_URL}/weightment/hourly`;
export const WEIGHTMENT_SCATTER = `${API_BASE_URL}/weightment/scatter`;
export const WEIGHTMENT_TARE_CONSISTENCY = `${API_BASE_URL}/weightment/tare-consistency`;
export const WEIGHTMENT_BY_WAGON = `${API_BASE_URL}/weightment/by-wagon`;
export const WEIGHTMENT_BY_MEMBER = `${API_BASE_URL}/weightment/by-member`;
export const WEIGHTMENT_FILTERS = `${API_BASE_URL}/weightment/filters`;
export const WEIGHTMENT_RAKE_REPORT = `${API_BASE_URL}/weightment/rake-report`;

// Control-plane / Dashboard endpoints
const CP = `${API_BASE_URL}/control-plane`;
export const CP_HIGHLIGHTS = `${CP}/highlights`;
export const CP_UPLOAD_TREND = `${CP}/upload-trend`;
export const CP_DOC_TYPE_BREAKDOWN = `${CP}/doc-type-breakdown`;
export const CP_VEHICLE_COMPLETION = `${CP}/vehicle-completion`;
export const CP_WEIGHT_ANALYTICS = `${CP}/weight-analytics`;
export const CP_RAKE_ANALYTICS = `${CP}/rake-analytics`;
export const CP_HOURLY_DISTRIBUTION = `${CP}/hourly-distribution`;
export const CP_TOP_UPLOADERS = `${CP}/top-uploaders`;
export const CP_DOCUMENT_EXPIRY = `${CP}/document-expiry`;
export const CP_OPERATIONS_TREND = `${CP}/operations-trend`;
export const CP_RECENT_ACTIVITY = `${CP}/recent-activity`;
export const CP_ENTITY_COUNTS = `${CP}/entity-counts`;
